module.exports = __webpack_public_path__ + "static/media/amtan.1472da49.png";